import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import AOS from 'aos';
import 'aos/dist/aos.css';
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';
import banner8 from '../assets/banner8.jpg';
import banner9 from '../assets/banner9.jpg';
import banner10 from '../assets/banner10.jpg';

import { IoMdAlert, IoMdCheckmarkCircleOutline, IoMdDocument } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneService from "./OneService";
import { TbDeviceCctv } from "react-icons/tb";
import { FaGun, FaPeopleGroup } from "react-icons/fa6";
import { MdCorporateFare } from "react-icons/md";


export default function ServicesBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	useEffect(() => {
    AOS.init({ duration: 1000, easing: 'ease-in-out', once: false });
    AOS.refresh(); // optional: refresh if content changes dynamically
  }, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-background"
				style={{
					paddingBottom: "50px",
				}}
			>
				<div 
					className="container pt-5"
					
				>
					
					<div className="row">

						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								Our Services
							</h6>
							<h6
								className="text-dim pb-3 text-center"
							>
								Zamani Sabios Group offers practical, evidence-based services across key organisational and development areas. Each service draws on the team’s extensive experience and sector knowledge to deliver solutions that strengthen performance and drive sustainable results.
							</h6>
						</div>

						<OneService
							image={banner1}
							title="MANAGEMENT CONSULTING"
							navToLink={{
								item: "services",
								subItem: "management-consulting"
							}}
						/>

						<OneService
							image={banner2}
							title="PROCUREMENT & SUPPLY CHAIN"
							navToLink={{
								item: "services",
								subItem: "procurement-supply-chain"
							}}
						/>

						<OneService
							image={banner3}
							title="FEASIBILITY STUDIES & EVALUATIONS"
							navToLink={{
								item: "services",
								subItem: "feasibility-evaluations"
							}}
						/>

						<OneService
							image={banner4}
							title="PROJECT & PROGRAMME REVIEWS"
							navToLink={{
								item: "services",
								subItem: "project-programme-reviews"
							}}
						/>

						<OneService
							image={banner8}
							title="INSTITUTIONAL CAPACITY DEVELOPMENT"
							navToLink={{
								item: "services",
								subItem: "capacity-development"
							}}
						/>

						<OneService
							image={banner6}
							title="MONITORING & EVALUATION"
							navToLink={{
								item: "services",
								subItem: "monitoring-evaluation"
							}}
						/>

						<OneService
							image={banner7}
							title="LEGAL & REGULATORY ADVISORY"
							navToLink={{
								item: "services",
								subItem: "legal-regulatory"
							}}
						/>

						<OneService
							image={banner4}
							title="ORGANISATIONAL CHANGE SUPPORT"
							navToLink={{
								item: "services",
								subItem: "organisational-change"
							}}
						/>

						<OneService
							image={banner9}
							title="POLICY & FINANCIAL ANALYSIS"
							navToLink={{
								item: "services",
								subItem: "policy-financial-analysis"
							}}
						/>

						<OneService
							image={banner10}
							title="MAPPING STUDIES & DEVELOPMENT COOPERATION"
							navToLink={{
								item: "services",
								subItem: "mapping-development"
							}}
						/>


					</div>
				</div>
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
